import { useCallback, useState } from "react";
import { AdminLogin } from "../components/admin/AdminLogin";
import { AdminDashboard } from "../components/admin/AdminDashboard";

const KEY = "woven_admin_token";

export default function Admin() {
  const [token, setToken] = useState(() => sessionStorage.getItem(KEY));

  const login = (t) => {
    sessionStorage.setItem(KEY, t);
    setToken(t);
  };
  const logout = useCallback(() => {
    sessionStorage.removeItem(KEY);
    setToken(null);
  }, []);

  return token ? <AdminDashboard token={token} onLogout={logout} /> : <AdminLogin onLogin={login} />;
}
